import React from 'react';
import { NAV_LINKS, WHATSAPP_PHONE, WHATSAPP_URL } from '../data/content';
export function Footer() {
  return <footer className="bg-cream py-16" data-id="element-229" data-mp="3ggaqtvj9sd5g">
      <div className="mx-auto max-w-content px-6 lg:px-10" data-id="element-230" data-mp="3ghc508vl1fre">
        <div className="flex flex-col gap-10 border-b border-ink/10 pb-12 lg:flex-row lg:items-start lg:justify-between" data-id="element-231" data-mp="32ovvqqc38li1">
          <div className="max-w-sm" data-id="element-232" data-mp="36ppkflxcu4bz">
            <p className="font-serif text-2xl tracking-[0.22em] text-ink" data-id="element-233" data-mp="3ufa4671c15mb">LUSSONOVO</p>
            <p className="mt-5 text-[13px] leading-relaxed text-stone-600" data-id="element-234" data-mp="3ud7ddkscv8gj">
              Reformas e interiorismo en Barcelona. Especialistas en pavimentos de madera, laminado
              y vinílico con el Sistema Suelo Perfecto™.
            </p>
          </div>
          <nav aria-label="Secciones" className="grid gap-3 sm:grid-cols-2" data-id="element-235" data-mp="3qbvm7atu2f68">
            {NAV_LINKS.map(link => <a key={link.href} href={link.href} className="text-[13px] text-stone-600 transition-colors duration-200 ease-premium hover:text-ink" data-id="element-236" data-mp="2a19tbleljmwr">
                {link.label}
              </a>)}
          </nav>
          <div className="text-[13px] text-stone-600" data-id="element-237" data-mp="3gca859wbi5ed">
            <p className="text-[11px] uppercase tracking-overline text-walnut" data-id="element-238" data-mp="3v89fgibls1ig">Contacto</p>
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="mt-4 block text-ink transition-colors duration-200 ease-premium hover:text-walnut" data-id="element-239" data-mp="3q83t9ho3r77r">
              WhatsApp · {WHATSAPP_PHONE}
            </a>
            <p className="mt-2" data-id="element-240" data-mp="htd1b43mfm3g">Barcelona y área metropolitana</p>
          </div>
        </div>
        <p className="pt-8 text-[11.5px] text-stone-400" data-id="element-241" data-mp="cu0icufvez65">
          © {new Date().getFullYear()} Lussonovo. Sistema Suelo Perfecto™. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}